var FORMS = (function($, window, document, undefined){
  var pub = {};
  var CONTACT_WEBHOOK_URL = 'https://hook.eu1.make.com/5g4c85xynxujkxmroc17prq8adutmkh9';
  var MIN_CONTACT_SUBMIT_SEC = 2.2;

  // Minimal serializer for simple forms (no files).
  function contactFormToObject($formEl){
    var obj = {};
    var arr = $formEl.serializeArray();
    for (var i = 0; i < arr.length; i++){
      var name = arr[i].name;
      // remove [] suffix for arrays
      if (name && name.slice(-2) === '[]'){
        name = name.slice(0, -2);
      }
      var value = arr[i].value;
      if (typeof obj[name] === 'undefined'){
        obj[name] = value;
      } else if (Array.isArray(obj[name])) {
        obj[name].push(value);
      } else {
        obj[name] = [obj[name], value];
      }
    }
    return obj;
  }

  // Contact form validation.
  function contactForm(){
    var form = $('#contact-form');
    var formLoadedAt = Date.now();
    var hasValidator = typeof $.fn.validate === 'function';

    if (!form.length){
      return;
    }

    // Always block native submit to avoid page reloads.
    form.off('submit.contactStop').on('submit.contactStop', function(e){
      if (e && e.preventDefault){ e.preventDefault(); }
    });

    function submitContact($form, evt){
      if (evt && evt.preventDefault){
        evt.preventDefault();
      }
      if ($form.attr('data-submit-locked') === 'true'){
        return false;
      }
      var $response = $('#form-response');
      var $submitBtn = $form.find('button[type="submit"]').first();
      var originalBtnText = $submitBtn.length ? $submitBtn.text() : null;
      var originalBtnHtml = $submitBtn.length ? $submitBtn.html() : null;
      var honeyValue = ($form.find('input[name="address"]').val() || '').trim();
      var isTooFast = (Date.now() - formLoadedAt) < MIN_CONTACT_SUBMIT_SEC * 1000;

      if ($submitBtn.length){
        $submitBtn.prop('disabled', true).html(
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>' +
          '<span class="ms-2">Sending…</span>'
        );
      }

      if (honeyValue || isTooFast){
        if ($response.length){
          $response.html('<div class="alert alert-danger" role="alert">Something went wrong. Please try again without using autocomplete to fill out fields.</div>');
        }
        if ($submitBtn.length){
          $submitBtn.prop('disabled', false).html(originalBtnHtml || originalBtnText || 'Send');
        }
        if (window && window.console && window.console.warn){
          window.console.warn('Contact form blocked (spam heuristics)', { honey: !!honeyValue, tooFast: isTooFast });
        }
        return false;
      }

      var payload = contactFormToObject($form);
      if (typeof payload.address !== 'undefined'){
        delete payload.address;
      }
      if (typeof payload.hp_contact !== 'undefined'){
        delete payload.hp_contact;
      }
      payload.meta = {
        form: 'contact',
        submittedAt: new Date().toISOString(),
        pageUrl: (window && window.location) ? window.location.href : null,
        userAgent: (navigator && navigator.userAgent) ? navigator.userAgent : null,
        country_name: null,
        city: null,
        region: null,
        ip: null
      };

      var geo = LOCALE.getGeoIpResult();

      return Promise.resolve(geo)
        .then(function(geo){
          if (geo){
            payload.meta.country_name = geo.country_name || geo.country || null;
            payload.meta.city = geo.city || null;
            payload.meta.region = geo.region || geo.region_name || null;
            payload.meta.ip = geo.ip || null;
          }
          return fetch(CONTACT_WEBHOOK_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          });
        })
        .then(function(res){
          if (!res.ok){
            throw new Error('Request failed: ' + res.status);
          }
          return res.text();
        })
        .then(function(resText){
          var message = 'Thank you for your enquiry. Our team will get back to you soon.';
          $form.attr('data-submit-locked', 'true');
          if ($submitBtn.length){
            // Keep disabled but restore original label (remove spinner).
            $submitBtn.prop('disabled', true).html('Sent');
          }
          var $actions = $form.find('.form-actions').first();
          var $msgTarget = $actions.length ? $actions.before('<div class="alert alert-success mb-3" role="alert">' + message + '</div>') : null;
          if ($response.length && !$msgTarget){
            $response.html('<div class="alert alert-success" role="alert">' + message + '</div>');
          }
        })
        .catch(function(err){
          var errorMessage = 'Sorry, there was a problem sending your message. Please try again.';
          if ($response.length){
            $response.html('<div class="alert alert-danger" role="alert">' + errorMessage + '</div>');
          }
          if (window && window.console && window.console.error){
            console.error(err);
          }
        })
        .finally(function(){
          if ($submitBtn.length && $form.attr('data-submit-locked') !== 'true'){
            $submitBtn.prop('disabled', false).html(originalBtnHtml || originalBtnText || 'Send');
          }
        });
    }

    if (!hasValidator){
      form.off('submit.contactFallback').on('submit.contactFallback', function(e){
        submitContact($(this), e);
      });
      return;
    }

    form.validate({
      rules: {
        name: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        message: {
          required: true
        }
      },
      messages: {
        name: 'Please enter your name.',
        email: {
          required: 'Please enter your email address.',
          email: 'Please enter a valid email address.'
        },
        message: 'Please enter your message.'
      },
      errorClass: 'is-invalid',
      validClass: 'is-valid',
      errorElement: 'div',
      errorPlacement: function(error, element){
        error.addClass('invalid-feedback');
        var wrapper = element.closest('.input-wrapper');
        if (wrapper.length){
          wrapper.append(error);
        }
        else {
          error.insertAfter(element);
        }
      },
      highlight: function(element){
        $(element).addClass('is-invalid');
      },
      unhighlight: function(element){
        $(element).removeClass('is-invalid');
      },
      submitHandler: function(formElement){
        return submitContact($(formElement));
      }
    });
  }

  function formFocus(){
    function getFieldContainer($field){
      var $wrapper = $field.closest('.input-wrapper');
      return $wrapper.length ? $wrapper : $field.closest('.form-item');
    }

    function updatePopulatedClass($field){
      var $container = getFieldContainer($field);
      var value = $field.val();
      var hasPlaceholder = $field.is('input, textarea') && typeof $field.attr('placeholder') !== 'undefined' && $field.attr('placeholder').trim() !== '';

      if ((value && value.trim() !== '') || hasPlaceholder){
        $container.addClass('populated');
      } else {
        $container.removeClass('populated');
      }
    }

    $(document).on('focus', '.form-control', function(){
      var $field = $(this);
      var prefix = $field.attr('data-prefix');
      getFieldContainer($field).addClass('focused');

      // Auto-insert prefix on focus when empty
      if (prefix && (!$field.val() || $field.val().trim() === '')){
        $field.val(prefix);
        updatePopulatedClass($field);
      }

      // Move caret to end to avoid prefix putting cursor at start.
      var el = $field.get(0);
      var type = el && el.type ? el.type.toLowerCase() : '';
      var canSelect = el && el.setSelectionRange && (
        type === 'text' ||
        type === 'search' ||
        type === 'url' ||
        type === 'tel' ||
        type === 'password' ||
        type === 'textarea'
      );
      if (canSelect){
        var len = el.value.length;
        setTimeout(function(){
          try { el.setSelectionRange(len, len); } catch (e) {}
        }, 100);
      }
    });

    $(document).on('blur', '.form-control', function(){
      var $field = $(this);
      var prefix = $field.attr('data-prefix');
      getFieldContainer($field).removeClass('focused');

      // Remove prefix-only value on blur
      if (prefix && $field.val() === prefix){
        $field.val('');
      }
      updatePopulatedClass($field);
    });

    $(document).on('input change', '.form-control', function(){
      var $field = $(this);

      // Strip the country code from the main phone field (not from the country-code field itself)
      if ($field.is('input[type="tel"]')) {
        if (($field.attr('autocomplete') || '').toLowerCase() === 'tel-country-code') return;

        var $item = $field.closest('.form-item');
        if (!$item.length) return;

        var $code = $item.find('input[autocomplete="tel-country-code"]').first();
        if (!$code.length) return;

        var codeRaw = ($code.val() || '').trim();
        var phone   = ($field.val() || '').trim();
        if (!codeRaw || !phone) return;

        var code = codeRaw.replace(/^\+/, '');

        // Escape for regex safety (just in case)
        code = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        // Remove +44 / 44 at the start + optional spaces/dashes
        var re = new RegExp('^\\+?' + code + '[\\s-]*');
        $field.val(phone.replace(re, ''));
      }


      updatePopulatedClass($field);
    });

    // Check initial state for pre-filled fields
    $('.form-control').each(function(){
      updatePopulatedClass($(this));
    });
  }

  if (typeof $.validator !== 'undefined'){
    $.validator.methods.email = function (value, element) {
      return this.optional(element) ||
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    };
    
    $.validator.addMethod('numericOnly', function(value, element){
      if (this.optional(element)){ return true; }

      var val = String(value || '').trim();
      return /^\d+$/.test(val);
    }, 'Please enter numbers only. No spaces or special characters.');

    $.validator.addClassRules('only-numeric', { numericOnly: true });
  }

  function setupValidation($form, extraOptions){
    if (!$form || !$form.length || typeof $.fn.validate !== 'function'){
      return null;
    }

    var defaults = {
      ignore: [],
      errorElement: 'div',
      errorClass: 'invalid-feedback d-block',
      normalizer: function(value){
        var el = this;
        var val = (value || '').trim();
        if (el && el.getAttribute){
          var prefix = el.getAttribute('data-prefix');
          if (prefix && val === prefix.trim()){
            // Clear prefix-only values so optional fields with prefixes don't validate as invalid.
            try { el.value = ''; } catch (e) {}
            return '';
          }
        }
        return val;
      },
      highlight: function(element){
        $(element).addClass('is-invalid');
        $(element).closest('.input-wrapper').addClass('has-error');
      },
      unhighlight: function(element){
        $(element).removeClass('is-invalid');
        $(element).closest('.input-wrapper').removeClass('has-error');
      },
      errorPlacement: function(error, element){
        var $el = $(element);
        var $wrap = $el.closest('.input-wrapper');
        if ($wrap.length){
          error.appendTo($wrap);
        } else {
          error.insertAfter($el);
        }
      },
      invalidHandler: function(form, validator){
        if (!validator || !validator.errorList || !validator.errorList.length){
          return;
        }
        var $first = $(validator.errorList[0].element);
        if (!$first.length){
          return;
        }

        var $overlay = $('#lboxOverlay');
        if ($overlay.length){
          var overlayTop = $overlay.offset().top;
          var target = Math.max(0, $overlay.scrollTop() + ($first.offset().top - overlayTop) - 150);
          $overlay.animate({ scrollTop: target }, 400);
        } else {
          $('html, body').animate({ scrollTop: Math.max(0, $first.offset().top - 150) }, 400);
        }
      }
    };
    return $form.validate($.extend(true, {}, defaults, extraOptions || {}));
  }

  function projectBriefForm(){
    var $form = $('#project-brief-form');
    if (!$form.length){
      return;
    }

    var MAX_BRIEF_UPLOAD_FILES = 3;

    var storageKeys = {
      selectedPackage: 'b48:selectedPackage',
      orderCustomer: 'b48:orderCustomer',
      orderPayment: 'b48:orderPayment',
      lastOrderDraft: 'b48:lastOrderDraft'
    };

    function normaliseFieldName(name){
      if (name && name.slice && name.slice(-2) === '[]'){
        return name.slice(0, -2);
      }
      return name;
    }

    function safeJsonParse(text){
      try { return JSON.parse(text); } catch (e){ return null; }
    }

    function readStorageJson(key){
      try {
        var raw = localStorage.getItem(key);
        return raw ? safeJsonParse(raw) : null;
      } catch (e){
        return null;
      }
    }

    function formToObject($formEl){
      var obj = {};
      var arr = $formEl.serializeArray();
      for (var i = 0; i < arr.length; i++){
        var name = normaliseFieldName(arr[i].name);
        var value = arr[i].value;
        if (typeof obj[name] === 'undefined'){
          obj[name] = value;
        } else if (Array.isArray(obj[name])) {
          obj[name].push(value);
        } else {
          obj[name] = [obj[name], value];
        }
      }
      return obj;
    }

    function ensureBriefResponse(){
      var $existing = $('#brief-response');
      if ($existing.length){
        return $existing;
      }
      var $resp = $('<div id="brief-response" class="mb-2"></div>');
      $('#brief-submit-wrap', $form).before($resp);
      return $resp;
    }

    function showBriefError(message){
      var $resp = ensureBriefResponse();
      $resp.html('<div class="alert alert-danger" role="alert">' + String(message || '') + '</div>');
    }

    function showBrandingUploadError(message){
      var $wrap = $('#branding-upload-wrap');
      if (!$wrap.length){
        showBriefError(message);
        return;
      }

      var $existing = $wrap.find('.brief-upload-error').first();
      if (!$existing.length){
        $existing = $('<div class="brief-upload-error alert alert-danger mt-2" role="alert"></div>');
        $wrap.append($existing);
      }
      $existing.text(String(message || ''));
    }

    function clearBrandingUploadError(){
      $('#branding-upload-wrap .brief-upload-error').remove();
    }

    var $existingBrandWrap = $('#existing-branding-wrapper');
    var $uploadInput = $('#brief-branding-files');
    var $physicalWrap = $('#physical-premises-wrap');
    var $physicalField = $('#brief-physical-premises');
    var briefValidator = setupValidation($form, {
      onfocusout: function(element){
        $(element).valid();
      },
      onkeyup: false
    });

    if ($uploadInput.length){
      $uploadInput.attr('data-max-files', String(MAX_BRIEF_UPLOAD_FILES));
      $(document)
        .off('change.b48BriefFiles', '#brief-branding-files')
        .on('change.b48BriefFiles', '#brief-branding-files', function(){
          try {
            var input = this;
            if (input && input.files && input.files.length > MAX_BRIEF_UPLOAD_FILES){
              showBrandingUploadError('Please upload ' + MAX_BRIEF_UPLOAD_FILES + ' files or fewer.');
              $(input).val('');
              return;
            }
            clearBrandingUploadError();
          } catch (e) {}
        });
    }

    function toggleBrandingUpload(){
      var value = $('input[name="existingBranding"]:checked', $form).val();
      if (!$existingBrandWrap.length){
        return;
      }
      if (value === 'Yes'){
        $existingBrandWrap.slideDown({
          duration: 250,
          start: function () {
            $(this).css('display', 'flex');
          }
        });
      } else {
        $existingBrandWrap.slideUp(250);
        if ($uploadInput.length){
          $uploadInput.val('');
        }
        clearBrandingUploadError();
      }
    }

    $(document).on('change', 'input[name="existingBranding"]', toggleBrandingUpload);

    function togglePhysicalPremises(){
      var value = $('input[name="physicalLocation"]:checked', $form).val();
      if (!$physicalWrap.length){
        return;
      }
      if (value === 'Yes'){
        $physicalWrap.slideDown({
          duration: 200,
          start: function () {
            $(this).css('display', 'flex');
          }
        });
      } else {
        $physicalWrap.slideUp(200);
        if ($physicalField.length){
          $physicalField.val('');
        }
      }
    }

    $(document).on('change', 'input[name="physicalLocation"]', togglePhysicalPremises);

    $(document).on('click', '.section-button', function(e){
      e.preventDefault();
      var $button = $(this);
      var $currentSection = $button.closest('.form-section');
      
      if (!$currentSection.length){
        return;
      }
      
      var $nextSection = $currentSection.next('.form-section');
      
      if ($nextSection.length){
        $nextSection.removeClass('collapsed').addClass('active');
        
        $button.hide();
        
        requestAnimationFrame(function(){
          var $scrollContainer = $('#lboxOverlay');
          
          if ($scrollContainer.length) {
            var container = $scrollContainer[0];
            var section = $nextSection[0];
            var scrollPosition = container.scrollTop + (section.getBoundingClientRect().top - container.getBoundingClientRect().top) - 200;
            
            $scrollContainer.animate({
              scrollTop: Math.max(0, scrollPosition)
            }, 800);
          } else {
            $('html, body').animate({
              scrollTop: $nextSection.offset().top - 200
            }, 800);
          }
        });
      }
    });

    toggleBrandingUpload();
    togglePhysicalPremises();

    var briefSubmitAttempts = 0;
    var briefRetryDelayTimer = null;
    var briefRetryDelayRemaining = 0;
    var briefMaxAttempts = 3;

    function renderBriefMessage(kind, text){
      var $resp = ensureBriefResponse();
      $resp.html('<div class="alert alert-' + kind + '" role="alert">' + String(text || '') + '</div>');
    }

    function setSubmitState($btn, disabled, label){
      if (!$btn || !$btn.length){ return; }
      $btn.prop('disabled', !!disabled);
      if (label){ $btn.text(label); }
    }

    function clearBriefRetryDelay(){
      if (briefRetryDelayTimer){
        clearInterval(briefRetryDelayTimer);
        briefRetryDelayTimer = null;
      }
      briefRetryDelayRemaining = 0;
    }

    function startBriefRetryDelay(seconds, $submitBtn, originalBtnText){
      briefRetryDelayRemaining = seconds;
      setSubmitState($submitBtn, true, 'Retry in ' + briefRetryDelayRemaining + 's');
      renderBriefMessage('danger', 'Couldn\'t submit your brief. Please wait a moment before retrying.');

      briefRetryDelayTimer = setInterval(function(){
        briefRetryDelayRemaining -= 1;
        if (briefRetryDelayRemaining <= 0){
          clearBriefRetryDelay();
          setSubmitState($submitBtn, false, originalBtnText);
          renderBriefMessage('info', 'Please submit your brief again.');
        } else {
          setSubmitState($submitBtn, true, 'Retry in ' + briefRetryDelayRemaining + 's');
        }
      }, 1000);
    }

    function handleBriefFailure($submitBtn, originalBtnText){
      briefSubmitAttempts += 1;
      clearBriefRetryDelay();

      if (briefSubmitAttempts >= briefMaxAttempts){
        renderBriefMessage('danger', 'Sorry about this &ndash; We\'ve hit a problem and we\'re investigating. Please try again soon.');
        setSubmitState($submitBtn, true, originalBtnText);
        return;
      }

      var delaySeconds = (briefSubmitAttempts === 1) ? 30 : 60;
      startBriefRetryDelay(delaySeconds, $submitBtn, originalBtnText);
    }

    function handleBriefSuccess($form){
      clearBriefRetryDelay();
      briefSubmitAttempts = 0;
      try {
        if (window.LEAD_CAPTURE && typeof window.LEAD_CAPTURE.clearLeadSession === 'function'){
          window.LEAD_CAPTURE.clearLeadSession();
        }
      } catch (e) {}
      $form.remove();

      $('#step-3-form .progress-bar').css('width', '100%');
      $('#step3-intro').hide();
      $('#step3-outro').show();
    }

    $(document)
      .off('submit.b48OrderBrief', '#project-brief-form')
      .on('submit.b48OrderBrief', '#project-brief-form', function(e){
        e.preventDefault();

        if (briefValidator && !$form.valid()){
          return;
        }

        var formEl = $form[0];
        if (!briefValidator && formEl && typeof formEl.checkValidity === 'function' && !formEl.checkValidity()){
          if (typeof formEl.reportValidity === 'function'){
            formEl.reportValidity();
          }
          return;
        }

        try {
          if (window.CHECKOUT && typeof CHECKOUT.stopOrderDeadlineTimer === 'function'){
            CHECKOUT.stopOrderDeadlineTimer();
          }
        } catch (err) {}

        var $resp = ensureBriefResponse();
        $resp.empty();

        var endpoint = 'https://hook.eu1.make.com/9p0bcyfu4rkrok6ade3bk26cfs40qo1n';
        var pkg = readStorageJson(storageKeys.selectedPackage);
        if (pkg && typeof pkg === 'object' && pkg.summary){
          pkg = $.extend({}, pkg);
          delete pkg.summary;
        }
        var customer = readStorageJson(storageKeys.orderCustomer);
        var orderPayment = readStorageJson(storageKeys.orderPayment);
        var brief = formToObject($form);

        var payload = {
          package: pkg,
          customer: customer,
          payment: orderPayment,
          brief: brief,
          meta: {
            submittedAt: new Date().toISOString(),
            userAgent: (navigator && navigator.userAgent) ? navigator.userAgent : null
          }
        };

        try { localStorage.setItem(storageKeys.lastOrderDraft, JSON.stringify(payload)); } catch (err) {}

        var $submitBtn = $form.find('button[type="submit"]').first();
        var originalBtnText = $submitBtn.length ? $submitBtn.text() : 'Submit Brief';
        var originalBtnHtml = $submitBtn.length ? $submitBtn.html() : null;
        if ($submitBtn.length){
          $submitBtn.prop('disabled', true).html(
            '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>' +
            '<span class="ms-2">Submitting…</span>'
          );
        }

        var fd = new FormData();

        try {
          var fileInputs = formEl.querySelectorAll('input[type="file"]');
          for (var i = 0; i < fileInputs.length; i++){
            var input = fileInputs[i];
            if (!input || !input.files || !input.files.length){
              continue;
            }
            var fieldName = normaliseFieldName(input.name || 'files[]');
            if (input.files.length > MAX_BRIEF_UPLOAD_FILES){
              showBrandingUploadError('Please upload ' + MAX_BRIEF_UPLOAD_FILES + ' files or fewer.');
              if ($submitBtn.length){
                $submitBtn.prop('disabled', false).html(originalBtnHtml || originalBtnText);
              }
              return;
            }
            for (var j = 0; j < input.files.length; j++){
              fd.append(fieldName, input.files[j]);
            }
          }
        } catch (e) {}

        fd.append('order', JSON.stringify(payload));

        var fetchOptions = { method: 'POST', body: fd };

        if (window.MAKE_API_KEY){
          fetchOptions.headers = { 'x-make-apikey': String(window.MAKE_API_KEY) };
        }

        fetch(endpoint, fetchOptions)
          .then(function(res){
            if (!res.ok){
              throw new Error('Server error: ' + res.status);
            }
            handleBriefSuccess($form);
          })
          .catch(function(){
            handleBriefFailure($submitBtn, originalBtnText);
          })
          .finally(function(){
            if ($submitBtn.length && !$submitBtn.prop('disabled') && $submitBtn.text() === 'Submitting…'){
              $submitBtn.html(originalBtnHtml || originalBtnText);
            }
          });
      });
  }

  pub.setupValidation = setupValidation;

  $(function(){
    contactForm();
    formFocus();
    projectBriefForm();
  });

  return pub;
})(jQuery, window, document);

